/*
 * @Author: Damon
 * @Date: 2020-09-21 10:58:33
 * @LastEditors: damon
 * @LastEditTime: 2022-12-30 15:52:12
 * @Description: file content
 */
/* eslint-disable no-shadow */
import {
  asyncRoutes,
  constantRoutes,
} from '@/router';

const SET_ROUTES = 'SET_ROUTES';
const SET_PERMISSIONS = 'SET_PERMISSIONS';
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasMenuPermission(menus, route) {
  //   if (route.meta && route.meta.roles) {
  //     return menus.some(menu => route.meta.roles.includes(menu));
  //   }
  if (route.menu === '') {
    return true;
  }
  if (route.menu) {
    const result = menus.some(menu => route.menu.includes(menu));
    return result;
  }
  return false;
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, menus) {
  const res = [];

  routes.forEach((route) => {
    const tmp = {
      ...route,
    };
    if (hasMenuPermission(menus, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, menus);
      }
      res.push(tmp);
    } else {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, menus);
      }
      if (tmp.children && tmp.children.length > 0) {
        tmp.redirect = `${tmp.path}/${tmp.children[0].path}`;
        res.push(tmp);
      }
    }
  });
  return res;
}

const state = {
  routes: constantRoutes,
  addRoutes: [],
  permissions: [],
};

const mutations = {
  [SET_ROUTES]: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  [SET_PERMISSIONS]: (state, permissions) => {
    state.permissions = permissions;
  },
};

const actions = {
  generateRoutes({
    commit,
  }, menus) {
    return new Promise((resolve) => {
      let accessedRoutes;
      if (menus.includes('admin')) {
        accessedRoutes = asyncRoutes || [];
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, menus);
      }
      commit(SET_ROUTES, accessedRoutes);
      resolve(accessedRoutes);
    });
  },
  generatePermissions({
    commit,
  }, permissions) {
    return new Promise((resolve) => {
      commit(SET_PERMISSIONS, permissions);
      resolve(permissions);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/permission.js